import { render } from "./ClientTableParentComponent.vue?vue&type=template&id=49b3f165"
import script from "./ClientTableParentComponent.vue?vue&type=script&lang=js"
export * from "./ClientTableParentComponent.vue?vue&type=script&lang=js"

import "./ClientTableParentComponent.vue?vue&type=style&index=0&id=49b3f165&lang=css"

import exportComponent from "D:\\a\\1\\s\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QSelect from 'quasar/src/components/select/QSelect.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import QTable from 'quasar/src/components/table/QTable.js';
import QInput from 'quasar/src/components/input/QInput.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QToggle from 'quasar/src/components/toggle/QToggle.js';
import QTh from 'quasar/src/components/table/QTh.js';
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import QTd from 'quasar/src/components/table/QTd.js';
import QPopupProxy from 'quasar/src/components/popup-proxy/QPopupProxy.js';
import qInstall from "../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QSelect,QBtn,QTable,QInput,QIcon,QToggle,QTh,QTooltip,QTd,QPopupProxy});
